<div class="container" [class.active]="selected | async">
  <filter-option [name]="name">
    {{ title }}
  </filter-option>
  <div *ngIf="selected | async" class="filter-padding">
    <ng-content></ng-content>
  </div>
</div>
